import { combineReducers } from '@reduxjs/toolkit';
import articleReducer from './features/articles/articleReducer';
import brandHubReducer from '../components/hub/brandHub/store/brandHubReducer';
import audienceHubReducer from '../components/hub/audienceHub/store/audienceHubReducer';
import pricingReducer from '../components/paymentJourneyRedesign/store/pricingReducer';
import discoveryReducer from './features/discovery';
import festivalProGuestsReducer from './features/festivalProGuests';
import igfEntriesReducer from './features/igfEntries';
import festivalProScheduleReducer from './features/festivalProSchedule';
import siteArticlesReducer from './features/siteArticles';
import siteArticleDetailsReducer from './features/siteArticles/siteArticleDetails';
import siteBaseSettingsReducer from './features/siteBaseSettings';

const rootReducer = {
  ...articleReducer,
  ...brandHubReducer,
  ...audienceHubReducer,
  ...pricingReducer,
  discovery: discoveryReducer,
  festivalProGuests: festivalProGuestsReducer,
  igfEntries: igfEntriesReducer,
  festivalProSchedule: festivalProScheduleReducer,
  site: combineReducers({
    articles: siteArticlesReducer,
    articleDetails: siteArticleDetailsReducer,
  }),
  siteBaseSettings: siteBaseSettingsReducer,
};

export default rootReducer;
